// DI Logos
import { IntegrationSoftwareCodes } from '@acp/shared';
import horizontalRGB from './assets/images/DI-Logo-Horizontal-RGB.png';
import horizontalRGBWhite from './assets/images/DI-Logo-Horizontal-orange.png';
import horizontalCharcoal from './assets/images/DI-Logo-Horizontal-Charcoal.png';
import horizontalWhite from './assets/images/DI-Logo-Horizontal-White.png';
import stackedRGB from './assets/images/DI-Logo-Stacked-RGB.png';
import stackedRGBWhite from './assets/images/DI-Logo-Stacked-RGB-Icon-White-Text.png';
import stackedCharcoal from './assets/images/DI-Logo-Stacked-Charcoal.png';
import stackedWhite from './assets/images/DI-Logo-Stacked-White.png';
import markOrange from './assets/images/DI-Logo-Mark-Orange.png';
import markWhite from './assets/images/DI-Logo-Mark-White.png';

// Brand icons - Default size
import activeNotice from './assets/icons/brand-icons/DI-Access-Issue.svg';
import property from './assets/icons/brand-icons/DI-Property.svg';
import quote from './assets/icons/brand-icons/DI-Quote.svg';
import invoice from './assets/icons/brand-icons/DI-Invoice.svg';
import newManagement from './assets/icons/brand-icons/DI-New-Management.svg';
import noActiveNotice from './assets/icons/brand-icons/DI-No-Access-Issues.svg';
import noResultInvoice from './assets/icons/brand-icons/DI-No-Results-Invoice.svg';
import noResultQuotes from './assets/icons/brand-icons/DI-No-Results-Quote.svg';
import noResultProperty from './assets/icons/brand-icons/DI-No-Results-Property.svg';
import noUrgentQuoteInvoice from './assets/icons/brand-icons/DI-No-Urgent-Quote-Invoice.svg';
import noDocuments from './assets/icons/brand-icons/DI-No-Documents.svg';
import urgentQuote from './assets/icons/brand-icons/DI-Urgent-Quote.svg';
import overdueInvoice from './assets/icons/brand-icons/DI-Overdue-Invoice.svg';
import serviceReport from './assets/icons/brand-icons/DI-Service-Report.svg';
import certificate from './assets/icons/brand-icons/DI-Certificate.svg';
import document from './assets/icons/brand-icons/DI-Document.svg';
import complianceIssue from './assets/icons/brand-icons/DI-Compliance-Issue.svg';
import pendingItems from './assets/icons/brand-icons/DI-Pending-Items.svg';

// Brand icons - Small size
import activeNoticeSm from './assets/icons/brand-icons/sm/DI-Access-Issue.svg';
import propertySm from './assets/icons/brand-icons/sm/DI-Property.svg';
import quoteSm from './assets/icons/brand-icons/sm/DI-Quote.svg';
import invoiceSm from './assets/icons/brand-icons/sm/DI-Invoice.svg';
import newManagementSm from './assets/icons/brand-icons/sm/DI-New-Management.svg';
import noActiveNoticeSm from './assets/icons/brand-icons/sm/DI-No-Access-Issues.svg';
import noResultInvoiceSm from './assets/icons/brand-icons/sm/DI-No-Results-Invoice.svg';
import noResultQuotesSm from './assets/icons/brand-icons/sm/DI-No-Results-Quote.svg';
import noResultPropertySm from './assets/icons/brand-icons/sm/DI-No-Results-Property.svg';
import noUrgentQuoteInvoiceSm from './assets/icons/brand-icons/sm/DI-No-Urgent-Quote-Invoice.svg';
import urgentQuoteSm from './assets/icons/brand-icons/sm/DI-Urgent-Quote.svg';
import overdueInvoiceSm from './assets/icons/brand-icons/sm/DI-Overdue-Invoice.svg';
import documentSm from './assets/icons/brand-icons/sm/DI-Document.svg';

// Brand icons - Small size - Muted
import activeNoticeSmMuted from './assets/icons/brand-icons/sm/muted/DI-Access-Issue.svg';
import urgentQuoteSmMuted from './assets/icons/brand-icons/sm/muted/DI-Urgent-Quote.svg';
import overdueInvoiceSmMuted from './assets/icons/brand-icons/sm/muted/DI-Overdue-Invoice.svg';
import invoiceSmMuted from './assets/icons/brand-icons/sm/muted/DI-Invoice.svg';
import quoteSmMuted from './assets/icons/brand-icons/sm/muted/DI-Quote.svg';
import newManagementSmMuted from './assets/icons/brand-icons/sm/muted/DI-New-Management.svg';
import serviceReportSmMuted from './assets/icons/brand-icons/sm/muted/DI-Service-Report.svg';
import certificatedSmMuted from './assets/icons/brand-icons/sm/muted/DI-Certificate.svg';
import documentSmMuted from './assets/icons/brand-icons/sm/muted/DI-Document.svg';

// Accreditation logos
import bronzeMasterElectrician from './assets/icons/accreditations/bronze_master_electrician.svg';
import fpaGoldMember from './assets/icons/accreditations/fpa_gold_member.svg';

// Placeholder images
import placeholderImg from './assets/images/placeholder/placeholder-image.png';

// Marketing images
import usingLaptopImg from './assets/images/marketing/using-laptop.jpg';

// Mobile apps images
import properlyAppImgDesktop from './assets/images/properly-app/properly-app-desktop.png';
import properlyAppImgMobile from './assets/images/properly-app/properly-app-mobile.png';
import properlyLogoBlackText from './assets/images/properly-app/properly-logo-black-text.svg';
import downloadGooglePlay from './assets/images/properly-app/download-google-play.svg';
import downloadAppStore from './assets/images/properly-app/download-app-store.svg';

// Software icons
import mriPropertyTree from './assets/icons/software-icons/mri-propertytree.svg';
import downloadOnAppStore from './assets/icons/software-icons/download-on-app-store.svg';
import qrCodeProperlyIos from './assets/icons/software-icons/qr-code-properly-ios.svg';
import qrCodeProperlyAndroid from './assets/icons/software-icons/qr-code-properly-android.svg';

export const diLogos = {
    horizontalRGB,
    horizontalRGBWhite,
    horizontalCharcoal,
    horizontalWhite,
    stackedRGB,
    stackedRGBWhite,
    stackedCharcoal,
    stackedWhite,
    markOrange,
    markWhite,
};

export const brandIcons = {
    // Primary - Default
    activeNotice,
    property,
    quote,
    invoice,
    newManagement,
    noActiveNotice,
    noResultInvoice,
    noResultQuotes,
    noResultProperty,
    noUrgentQuoteInvoice,
    noDocuments,
    urgentQuote,
    overdueInvoice,
    serviceReport,
    certificate,
    document,
    complianceIssue,
    pendingItems,
    // Primary - Sm
    activeNoticeSm,
    propertySm,
    quoteSm,
    invoiceSm,
    newManagementSm,
    noActiveNoticeSm,
    noResultInvoiceSm,
    noResultQuotesSm,
    noResultPropertySm,
    noUrgentQuoteInvoiceSm,
    urgentQuoteSm,
    overdueInvoiceSm,
    documentSm,
    // Muted - Sm
    activeNoticeSmMuted,
    urgentQuoteSmMuted,
    overdueInvoiceSmMuted,
    quoteSmMuted,
    invoiceSmMuted,
    newManagementSmMuted,
    serviceReportSmMuted,
    certificatedSmMuted,
    documentSmMuted,
};

export const accreditationLogos = {
    bronzeMasterElectrician,
    fpaGoldMember,
};

export const placeholder = {
    placeholderImg,
};

export const marketing = {
    usingLaptopImg,
};

export const softwareIcons = {
    mriPropertyTree,
    downloadOnAppStore,
    qrCodeProperlyIos,
    qrCodeProperlyAndroid,
};

export const mobileApps = {
    properlyAppImgDesktop,
    properlyAppImgMobile,
    properlyLogoBlackText,
    downloadGooglePlay,
    downloadAppStore,
};

export function getSoftwareIconByCode(code: string | null) {
    switch (code) {
        // Add more cases as needed
        case IntegrationSoftwareCodes.PropertyTree:
            return softwareIcons.mriPropertyTree;
        default:
            return '';
    }
}

export function getBrandIconByName(name: string): string | null {
    return Object.hasOwn(brandIcons, name)
        ? brandIcons[name as keyof typeof brandIcons]
        : null;
}

export function getDocumentIconByType(type: string) {
    switch (type) {
        case 'QUOTE_DOCUMENT':
            return brandIcons.quoteSmMuted;
        case 'INVOICE_DOCUMENT':
            return brandIcons.invoiceSmMuted;
        case 'SERVICE_REPORT_DOCUMENT':
            return brandIcons.serviceReportSmMuted;
        case 'CERTIFICATE_DOCUMENT':
            return brandIcons.certificatedSmMuted;
        default:
            return brandIcons.documentSmMuted;
    }
}
